<template>
    <Progressbar v-if="loading && !isInit" />
    <NetworkError v-else-if="!isInit && !birthdays.length && errors" @tryAgain="getBirthdays" />
    <div class="w-full h-full bg-gray-200 dark:bg-base-100 rounded-tr-3xl xl:px-9 pt-6 lg:pt-10 pb-14 " v-else>
        <div class="container dark:bg-base-300 bg-white p-3">
            <FullCalendar class='app-calenda' :options='calendarOptions'>
                <template v-slot:eventContent='arg'>
                    <VTooltip>
                        <div class="flex items-center px-1 cursor-pointer">
                            <div class="mr-1">
                                <span class="block text-sm font-semibold">{{ arg.event.title }}</span>
                                <span class="block text-sm">{{ arg.event.extendedProps.phone }}</span>
                            </div>
                        </div>
                        <template #popper>
                            <div class='flex flex-col'>
                                <span class="text-sm">{{ __('Name') }}: <span>{{ arg.event.title }}</span></span>
                                <span class="text-sm">{{ __('Mobile') }}: <span>{{ arg.event.extendedProps.phone
                                        }}</span></span>
                                <span class="text-sm">{{ __('Account name') }}: {{ arg.event.extendedProps.account_name
                                }}</span>
                            </div>
                        </template>
                    </VTooltip>
                </template>
            </FullCalendar>
        </div>
    </div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import momentPlugin from '@fullcalendar/moment'
const { getBirthdays, loading, birthdays, errors, router, route } = useDashboard();
const handleEventClick = (info) => {
    router.push({ name: 'user.person.show', params: { id: info.event.id } });
}

const isInit = ref(false);
const lastStartDate = ref(route.query.start)
const lastEndDate = ref(route.query.end)

const handleDatesSet = async (dateInfo) => {

    if (lastStartDate.value !== dateInfo.startStr.slice(0, 10) && lastEndDate.value !== dateInfo.endStr.slice(0, 10)) {
        lastStartDate.value = dateInfo.startStr.slice(0, 10);
        lastEndDate.value = dateInfo.endStr.slice(0, 10);
        await getBirthdays({ start: lastStartDate.value, end: lastEndDate.value });
        isInit.value = true;
    }
}


const initialDate = computed(() => route.query.start || new Date().toISOString().slice(0, 10))

const calendarOptions = computed(() => ({
    plugins: [dayGridPlugin, timeGridPlugin, listPlugin, momentPlugin],
    headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'listWeek,dayGridMonth,timeGridWeek'
    },
    buttonText: {
        today: window.i18n['Today'],
        month: window.i18n['Month'],
        week: window.i18n['Week'],
        day: window.i18n['Day'],
        listWeek: window.i18n['Programs']
    },
    locale: 'fa',
    direction: 'rtl',
    initialView: 'dayGridMonth',
    initialDate: initialDate.value,
    selectable: true,
    selectMirror: true,
    allDaySlot: false,
    eventDisplay: 'block',
    eventMinHeight: 45,
    dayMaxEvents: true,
    navLinks: true,
    firstDay: -1,
    events: birthdays.value ?? [],
    datesSet: handleDatesSet,
    eventClick: handleEventClick
}));

</script>